module.exports = __webpack_public_path__ + "img/Middle-Horizontal-Rectangular-Attachment-12.b0369837.png";